import { format, isValid, isBefore, isEqual } from 'date-fns';

export const validTime = (dates) => {
  //Mandar en orden, date[0] es la fecha de comienzo
  //date[1] es fecha final
  //expresion regular para validar yyyy-MM-dd
  const regex = /^20[\d]{2}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
  //
  //utiliza el validador de date-fns
  const validCondition = dates.every((date) => isValid(date));

  //valido que el formato que me vaya a devolver format coincida con el correcto yyyy-MM-dd siempre y cuando trabaje con fechas validas
  const validFormatDate = validCondition
    ? dates.every((date) => regex.test(format(date, 'yyyy-MM-dd')))
    : validCondition;
  const validMaxDate = validCondition
    ? dates.every(
        (date) =>
          isBefore(
            new Date(date.setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(0, 0, 0, 0)),
          ) ||
          isEqual(
            new Date(date.setHours(0, 0, 0, 0)),
            new Date(new Date().setHours(0, 0, 0, 0)),
          ),
      )
    : validCondition;

  if (dates.length === 2) {
    // valido que la fecha de comienzo sea anterior a la de fin siempre y cuando trabaje con fechas validas
    const validDateStartCondition = validCondition
      ? isBefore(
          new Date(dates[0].setHours(0, 0, 0, 0)),
          new Date(dates[1].setHours(0, 0, 0, 0)),
        ) ||
        isEqual(
          new Date(dates[0].setHours(0, 0, 0, 0)),
          new Date(dates[1].setHours(0, 0, 0, 0)),
        )
      : validCondition;

    return (
      validCondition &&
      validDateStartCondition &&
      validFormatDate &&
      validMaxDate
    );
  } else {
    return validCondition && validFormatDate && validMaxDate;
  }
};
